import React, { useState, useContext, MouseEvent, useEffect, useCallback } from 'react';
import GameConfigContext, { TileProps } from '../../../contexts/GameConfigContext/GameConfigContext';
import { TileBox, HiddenContent, TileInner, Boom, Flag } from './Tile.css';

const Tile = (props: TileProps & { x:number; y: number}): JSX.Element => {
  const { gameConfig, setGameConfig, showTileByXY } = useContext(GameConfigContext);
  const [ markedAsBomb, setMarkedAsBomb ] = useState(props.flagged);
  const [isMouseDown, setIsMouseDown] =  useState(false);

  useEffect(() => {
    // if (gameConfig.reloaded) {
      console.log('reloaded');
      setMarkedAsBomb(false);
    // }
  }, [gameConfig.reloaded]);

  const handleMarkBomb = useCallback((event: MouseEvent<HTMLDivElement>) => {
    if('preventDefault' in event)
      event.preventDefault();
    if (gameConfig.gameOver || !gameConfig.tiles[props.x][props.y].hidden) {
      return;
    }
    if (gameConfig.flagCount >= gameConfig.bombCount && !markedAsBomb) {
      return;
    }
    setMarkedAsBomb(!markedAsBomb);
    const flagCount = markedAsBomb ? gameConfig.flagCount - 1 : gameConfig.flagCount + 1;
    let correctCount = gameConfig.correctCount;
    let win = false;
    let reloaded = gameConfig.reloaded;
    let gameOver = false;
    if (gameConfig.tiles[props.x][props.y].bomb && !markedAsBomb) {
      correctCount++;
    }
    if (gameConfig.tiles[props.x][props.y].bomb && markedAsBomb) {
      correctCount--;
    }

    let flagTile = [...gameConfig.tiles];
    flagTile[props.x][props.y].flagged = !markedAsBomb;

    if (correctCount === gameConfig.bombCount && isEveryTileNotHidden()) {
      gameOver = true;
      win = true;
      reloaded = !reloaded;
      // odkryj bomby
      flagTile = flagTile.map((tile:TileProps[]) => tile.map((til:TileProps) => {
        return til.bomb ? {...til, hidden: false, flagged: false} : til;
      }));
    }

    setGameConfig({...gameConfig, tiles: flagTile, flagCount, correctCount, win, gameOver, reloaded, started: true});
    return false;
  }, [gameConfig]);

  const isEveryTileNotHidden = useCallback(() => {
    let result = true;
    for (let x = 0; x < gameConfig.areaTilesHeightNum; x++) {
      for (let y = 0; y < gameConfig.areaTilesWidthNum; y++) {
        if (gameConfig.tiles[x][y].hidden && !gameConfig.tiles[x][y].bomb) {
          result = false;
        }
      }
    }
    return result;
  }, [gameConfig.tiles])

  const handleShowTile = useCallback((event: React.MouseEvent<HTMLElement>) => {
    if (gameConfig.gameOver || gameConfig.tiles[props.x][props.y].flagged || event.button > 0) {
      return;
    }

    setIsMouseDown(false);

    const copyTiles = showTileByXY(props.x, props.y, [...gameConfig.tiles], 0) as { tiles: TileProps[][], gameOver: boolean, flagCount: number };

    let win = false;
    let reloaded = gameConfig.reloaded;

    if (isEveryTileNotHidden()) {
      copyTiles.gameOver = true;
      win = true;
      reloaded = !reloaded;
      copyTiles.tiles = copyTiles.tiles.map((tile:TileProps[]) => tile.map((til:TileProps) => {
        return til.bomb ? {...til, hidden: false, flagged: false} : til;
      }));
    }

    setGameConfig({...gameConfig, tiles: copyTiles.tiles, flagCount: copyTiles.flagCount, gameOver: copyTiles.gameOver, started: true, win, reloaded});
  }, [gameConfig]);

  const handleMouseLeave = () => {
    setIsMouseDown(false);
  };

  const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
    if (window.isMouseDown && event.button === 0 && (!gameConfig.gameOver && !gameConfig.tiles[props.x][props.y].flagged)) {
      setIsMouseDown(true);
    }
  };

  const handleMouseDown = (event: React.MouseEvent<HTMLElement>) => {
    if (event.button === 0 && !gameConfig.gameOver)
      setIsMouseDown(true);
  }

  return (
    <TileBox size={gameConfig.tileSize} onClick={handleMouseDown} onMouseUp={handleShowTile} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onContextMenu={handleMarkBomb}>
      <TileInner mouseDown={isMouseDown} size={gameConfig.tileSize}>
        {markedAsBomb && <Flag size={gameConfig.tileSize} />}
      </TileInner>
      {(props.bomb && !props.hidden) && <Boom size={gameConfig.tileSize} />}
      {(!props.hidden && !props.bomb) && <HiddenContent size={gameConfig.tileSize} count={props.bombsNear}></HiddenContent>}
    </TileBox>
  );
};

export default Tile;
